import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";

import LoadingData from "$/lib/components/molecules/LoadingData/LoadingData";
import { useAuth } from "$/lib/providers/AuthProvider";
import { ROUTES } from "$/lib/utils/constants/routes.constants";

export const Route = createFileRoute("/_authentication-layout")({
  component: AuthLayoutComponent,
});

function AuthLayoutComponent() {
  const { user, isFetching } = useAuth();

  if (isFetching) 
    return (
    <div className="flex min-h-screen items-center justify-center">
      <LoadingData />
    </div>
  );
    

  if (user && !user.isVerified) {
    // TODO: infer the typing from `Navigate`
    // @ts-expect-error state typing
    return <Navigate to={ROUTES.VERIFY_EMAIL} state={{ fromAuth: true }} />;
  }

  if (user) return <Navigate to={ROUTES.HOMEPAGE} />;

  return <Outlet />;
}
